<template>
    <div class="steps">
        <div class="d-none d-md-block border-right">
            <el-steps direction="vertical" :active="step" finish-status="success" style="height: 400px;">
                <el-step v-for="(item, index) in steps" :key="index" :title="item.title"
                    :description="item.description"></el-step>
            </el-steps>
        </div>

        <div class="d-block d-md-none mb-4">
            <el-steps :active="step" finish-status="success" align-center>
                <el-step v-for="(item, index) in steps" :key="index" :title="item.title"></el-step>
            </el-steps>
        </div>
    </div>


</template>

<script>
export default {
    props: {
        step: {
            type: Number,
            required: true,
            default: 0,
        },
        steps: {
            type: Array,
            required: false,
            default: {}
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Steps.vue